import React, {Fragment, useState, useEffect} from 'react'
import * as RouterActions from '../../actions/RouterActions'
import {Table, Popup, Modal, Icon, Loader, Button} from 'semantic-ui-react'
import {useFirebase, useFirestore, useFirestoreConnect} from 'react-redux-firebase';
import {useDispatch, useSelector} from 'react-redux';
import Dropzone from 'react-dropzone';
import * as moment from 'moment'
import {env} from '../../constants/Environment';
import { nanoid } from 'nanoid'

const _ = require('lodash');

export default function Fileselect(props) {
    moment.locale('de');
    const dispatch = useDispatch()
    const [path, setPath] = useState(props.path);
    const firestore = useFirestore();
    const [selectedFile, setSelectedFile] = useState(null);

    useFirestoreConnect({
      collection: 'environments/' + env + '/staticfiles',
      where: ['path', '==', path.join('/').toLowerCase()],
      orderBy: [['created', 'desc']]
    })

    const files = useSelector((state) => state.firestore.ordered['environments/' + env + '/staticfiles']);

    return (
       
        <Modal
            onClose={() => props.onCancel()}
            open={true}
        >
            <Modal.Header>Datei auswählen...</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <div>
                        <div style={{
                            marginBottom: '1em',
                            backgroundColor: '#EEEEEE',
                            padding: '0.5em',
                            borderRadius: '5px'
                        }}>
                            <a style={{
                                    cursor: 'pointer'
                                }} onClick={(e) => {
                                setSelectedFile(null);
                                setPath([]);
                            }}>Statische Dateien</a>
                            {
                                path.map((p, idx) => (<Fragment> / <a style={{
                                    cursor: 'pointer'
                                }} onClick={(e) => {
                                    setSelectedFile(null);
                                    setPath(path.slice(0, idx + 1));
                                }}>{p}</a></Fragment>))
                            }
                        </div>
                        
                        {
                            (typeof files !== 'undefined' && files !== null)?
                                files.map((file) => {
                                    if(typeof file.deleted !== 'undefined' && file.deleted)return null;
                                    
                                    if(file.type === 'folder'){
                                        return (
                                            <div style={{
                                                cursor: 'pointer',
                                                padding: '0.5em 0'
                                            }} onClick={(e) => {
                                                setSelectedFile(null);
                                                setPath([...path, file.name]);
                                            }}>
                                                <Icon name="folder" /> {file.name}
                                            </div>
                                        )
                                    }else{
                                        return null;
                                    }
                                })
                            :null
                        }

                        <div style={{
                            
                        }}>

                        {
                            (typeof files !== 'undefined' && files !== null)?
                                files.map((file) => {
                                    if(file.type === 'file'){
                                        if(typeof file.deleted !== 'undefined' && file.deleted)return null;

                                        return (
                                            <div style={{
                                                cursor: 'pointer',
                                                padding: '0.5em 0',
                                                display: 'flex',
                                                ...(selectedFile !== null && file.id === selectedFile.id)?{
                                                    border: '1px dotted #cccccc',
                                                    backgroundColor: '#2185d0',
                                                    color: '#FFFFFF'
                                                }:{}
                                            }} onClick={(e) => {
                                               setSelectedFile(file);
                                            }}>
                                                <div style={{flexGrow: 1}}><Icon name="file" /> {file.originalName}</div>
                                                <div>{moment(file.created.toDate()).format('dddd, Do MMMM YYYY, H:mm:ss')}</div>
                                                <div style={{marginLeft: '1em'}}><Button size="tiny" color="grey" onClick={(e) => window.open(file.fileUrl)}>Vorschau</Button></div>
                                            </div>
                                        )
                                    }else{
                                        return null;
                                    }
                                })
                            :null
                        }

                        </div>
                    </div>
                </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
            <Button color='black' onClick={() => props.onCancel()}>
                Abbrechen
            </Button>
            <Button
                content="Datei zuordnen"
                disabled={selectedFile === null}
                labelPosition='right'
                icon='checkmark'
                onClick={() => props.onSelectFile(selectedFile)}
                positive
            />
        </Modal.Actions>
        </Modal>
    )
}